import { PasswordFeedback, TermsSignupMessage } from '@/components/shared';
import { Button, useDisclosure } from '@chakra-ui/react';
import type { SubmitHandler } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { hasSpecialChar, hasUpperLetter, minLength } from '../../constants';
import { hasEmptyFields } from '@/utils';
import { PasswordInput } from '../shared';

interface ISimpleSignUpFormProps {
  onSubmit?: (data: { password: string }) => void;
}

export const SimpleSignUpForm: React.FC<ISimpleSignUpFormProps> = ({
  onSubmit: providedOnSubmit,
}): JSX.Element => {
  const { t } = useTranslation();
  const { isOpen, onClose, onOpen } = useDisclosure();

  const {
    formState: { errors },
    getValues,
    handleSubmit: submitHandler,
    register,
    watch,
  } = useForm<{ password: string }>({ mode: 'all', criteriaMode: 'all' });

  const areRequiredFieldsEmpty = hasEmptyFields(watch());
  const isDisabled = !!errors.password?.types || areRequiredFieldsEmpty;

  const handleSubmit: SubmitHandler<{ password: string }> = (data, event): void => {
    event?.preventDefault();
    providedOnSubmit?.(data);
  };

  return (
    <form
      autoComplete="off"
      id="simple-signup-form"
      name="simple-signup-form"
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onSubmit={submitHandler(handleSubmit)}
    >
      <PasswordFeedback
        error={errors.password}
        isOpen={isOpen}
        value={getValues('password')}
        onClose={onClose}
      >
        <PasswordInput
          error={errors.password}
          id="password"
          placeholder={t('FORM.PASSWORD')}
          {...register('password', {
            required: true,
            validate: {
              minLength: (value) => minLength(value, 8),
              hasUpperLetter,
              hasSpecialChar,
            },
            onBlur: onClose,
            onChange: () => {
              if (!isOpen) onOpen();
            },
          })}
        />
      </PasswordFeedback>
      <Button disabled={isDisabled} mt={8} type="submit" variant="mbeSecondary" w="full">
        {t('ACTIONS.CONFIRM')}
      </Button>
      <TermsSignupMessage />
    </form>
  );
};
